module.exports = __webpack_public_path__ + "img/group_cover_image.50f6826f.svg";